export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";